export default __webpack_public_path__ + "img/kaombo sul.23b0765c.jpg";